<div
  class="info-page"
  [class.desktop]="isZeroDesktop() || isFinnetDesktop()"
  [attr.data-tab]="tab()"
>
  @if (isFinnetDesktop()) {
    <div class="finnet-desktop-header">
      <h2 class="finnet-desktop-title" #cardTitle tabindex="-1">{{ heading() }}</h2>
    </div>
  } @else if (isFinnet()) {
    <div class="header">
      <h2 class="title" #cardTitle tabindex="-1">{{ heading() }}</h2>
    </div>
  } @else {
    <div [class]="isZeroDesktop() ? 'desktop-header' : 'header'">
      <div class="header-title">
        @if (icon()) {
          <span class="icon" [style.--icon-url]="'url(' + icon() + ')'"></span>
        }
        <h2 class="title" #cardTitle tabindex="-1">{{ heading() }}</h2>
      </div>
    </div>
  }

  @if (content(); as article) {
    <div class="body">
      <div class="hero">
        <img
          [src]="article.image.src"
          [style.width.px]="article.image.width"
          [style.height.px]="article.image.height"
          alt=""
        />
      </div>
      <h3 class="page-title">{{ article.title }}</h3>
      <p class="text">{{ article.intro }}</p>
      <h4 class="subtitle">{{ article.whyTitle }}</h4>
      <p class="text">{{ article.why }}</p>
      <h4 class="subtitle">{{ article.showsTitle }}</h4>
      <ul class="shows">
        @for (item of article.shows; track $index) {
          <li>
            <strong>{{ item.lead }}:</strong> {{ item.text }}
          </li>
        }
      </ul>
      @if (article.conclusion) {
        <p class="text">{{ article.conclusion }}</p>
      }
      <h4 class="subtitle">{{ article.usageTitle }}</h4>
      <ul class="usage">
        @for (item of article.usage; track $index) {
          <li>{{ item }}</li>
        }
      </ul>
      @if (article.closingNote; as note) {
        <p class="text">
          @for (run of note; track $index) {
            @if (run.bold) {
              <strong>{{ run.text }}</strong>
            } @else {
              {{ run.text }}
            }
          }
        </p>
      }
      <p class="disclaimer">{{ disclaimer }}</p>
    </div>
  }
</div>
